module.exports = __webpack_public_path__ + "img/entryway-benches.42040f8.jpg";